import { useDeviceType } from "@dash/mq";
import { HeaderBar, Page } from "@dash/page";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom-v5-compat";

import { getMegaraxPath } from "@megaron/megarax-uri";
import { Uuid } from "@megaron/uuid";

import { SupportCreateTicketFormBody } from "../create/SupportCreateTicketFormBody";
import { useSupportCreateTicketForm } from "../create/useSupportCreateTicketForm";

type Props = {
  listPath?: string;
};

export const SupportCreateTicketPage = ({ listPath = getMegaraxPath.uri("megarax://support/tickets") }: Props) => {
  const navigate = useNavigate();
  const { isMobile } = useDeviceType();
  const [searchParams] = useSearchParams();
  const customerUuidParam = searchParams.get("customerUuid");
  const customerUuid = customerUuidParam ? Uuid(customerUuidParam) : undefined;

  const form = useSupportCreateTicketForm({
    listPath,
    customerUuid,
    defaultReporterEmail: searchParams.get("reporterEmail") ?? undefined,
    defaultReporterFirstName: searchParams.get("reporterFirstName") ?? undefined,
    defaultReporterLastName: searchParams.get("reporterLastName") ?? undefined,
    defaultReporterName: searchParams.get("reporterName") ?? undefined,
  });

  useEffect(() => {
    document.title = "Nowe zgłoszenie";
  }, []);

  return (
    <>
      <HeaderBar header="Nowe zgłoszenie" onGoBack={() => navigate(listPath)} />
      <Page
        css={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          marginTop: isMobile ? "4.5rem" : "5.5rem",
          padding: isMobile ? "0 1rem" : "0 2rem",
          marginBottom: "2rem",
        }}
      >
        <SupportCreateTicketFormBody isMobile={isMobile} {...form} />
      </Page>
    </>
  );
};
